module.exports = __webpack_public_path__ + "img/desburocratizacao.6efe740f.png";